import "./countryAccess.css";
import Loading from "../../base/loading/loading";
import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

let query = `     
{
  
    landingAccessCollection(where: {slug: "landing-access-sv"}) {
    items{
        internalName
        pageTitle
        slug
        seoMetadata{
            description
            hreflang
            href
            canonicalHref
        }
      logo{
        url
      }
      mainText{
        json
      }
      accessButtons
      mainImage {
        url
      }
      backgroundImage{
        url
      }
    }
        }
}
`


const CountryAccess = () => {

    const [page, setPage] = useState(null);
    const location = useLocation();


    useEffect(()=>{

        const url = String(location.pathname).split("/");
        const slug = url[2];
        console.log("slug", slug);
        query = query.replace('&slug&', slug)
        window
        .fetch(`https://graphql.contentful.com/content/v1/spaces/5btn2y9mgkqy/`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            // Authenticate the request
            Authorization: "Bearer b3AQUpg-vBOOEAh9q_GsxA5r5Iq170qfW8BnsdAjObE",
            },
            // send the GraphQL query
            body: JSON.stringify({ query  }),
        })
        .then((response) => response.json())
        .then(({ data, errors }) => {
            if (errors) {
            console.error("erros", errors);
            }

           console.log('data', data.landingAccessCollection.items[0])

            setPage(data.landingAccessCollection.items[0]);
        });

    }, [])



    if (!page) {
        return(<Loading />)
    }

  return (
    <div
      className="container-fluid contry-access-container"
      style={{ backgroundImage: `url(${page.backgroundImage.url})` }}
    >
       <Helmet htmlAttributes={{ lang : page.seoMetadata.hreflang }}>
            <meta charSet="utf-8" />
            <title>{page.pageTitle}</title>
            <meta name="description" content={page.seoMetadata.description}></meta>
            <meta name="keywords" content={page.seoMetadata.keywords}></meta>
            <link
            rel="alternate"
            hreflang={page.seoMetadata.hreflang}
            href={page.seoMetadata.href}
            />
            <link rel="canonical" href={page.canonicalHref} />
        </Helmet>
      <div className="container  h-100">
        <div className="row h-100">
          <div className="col-md-7 col-xs-12  ">
            <div className="pt-4">
              <img className="logo col-6 col-md-4 pt-4" src={page.logo.url} alt="logo tigo" />
            </div>
            <div>
              {/* <div className="col-10 pt-4">
                <div className="h1-access p-4">
                  Paga todo y atodos con Tigo Money.
                </div>
              </div>
              <div className="ps-4 p-access">
                Paga tus cuentas, compra, envía o recibe dinero.
              </div> */}
              <div className="col-10 pt-4 main-text-access">
                {documentToReactComponents(page.mainText.json)}
              </div>
              <div className="p-4 btn-acces-container ">
                <div>
                  <span className="label-btn-access">{page.accessButtons.items[0].text}</span>
                  <div className="pt-1">
                    <a href={page.accessButtons.items[0].cta}>
                        <button className="btn btn-access-active col-12">
                        {/* Realiza transacciones */}
                            <b>{page.accessButtons.items[0].label}</b>
                        
                        </button>
                    </a>
                  </div>
                </div>
                <div>
                  <div className="pt-4">
                    <span className=" label-btn-access">
                      {page.accessButtons.items[1].text}
                    </span>
                    <div className="pt-1">
                        <a href={page.accessButtons.items[1].cta}>
                            <button className="btn btn-access col-12">
                                <b>{page.accessButtons.items[1].label}</b>
                            </button>
                        </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 h-100  d-none d-sm-block d-sm-none d-md-block ">
                <div className=" h-100 d-flex align-items-center  ">
                    <img src={page.mainImage.url} className="   main-img-access "  alt="skdfjd" />
                </div>
                    
                
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryAccess;
